import { DateHelper } from '../util/dateHelper';
import { Deserializable } from './deserializable';


export class DeviceState implements Deserializable {

  serial: string;
  state: string;  // Lowered, NotLowered, Error
  date: string;
  dateDate: Date;
  desc: string;
  forcedLow: boolean;
  synchronizing: boolean;

  forcedLowActive: boolean;
  forcedLowReason:  string;

  deserialize(input: any) {

    Object.assign(this, input);

    this.dateDate = new Date(input.date);

    return this;
  }

  isError(): boolean {

    return "Error" == this.state;
  }

}
